import React, { useRef, useState } from 'react'
import { Button, Card, Col, Container, Form, InputGroup, Row, Toast } from 'react-bootstrap';
import { useLocation, useNavigate } from "react-router-dom";
import { useAppDispatch } from '../app/hooks';
import { resetPasswordAsync } from '../slices/profile.slice';


import solarSharelogo from '../assets/images/rex-logo.png';

export interface ResetPasswordRequest {
  username: string | null;
  resetPasswordToken: string | null;
  newPassword: string | undefined;
}

const ResetPassword = () => {

  const PASSWORD_REGEX = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[!@#$%^&*])(?=.{8,})/;

  const newPassRef = useRef<HTMLInputElement>(null);
  const newConfPassRef = useRef<HTMLInputElement>(null);

  const [hasTochedNewPass, setHasTochedNewPass] = useState(false);
  const [hasTochedNewConfPass, setHasTochedNewConfPass] = useState(false);

  const [showNewPass, setShowNewPass] = useState(false);
  const [showNewConfPass, setShowNewConfPass] = useState(false);

  const [isValidNewPass, setValidNewPass] = useState(false);
  const [isValidNewConfPass, setValidNewConfPass] = useState(false);

  const navigate = useNavigate();
  const location = useLocation();

  const [succuss, setSuccess] = useState(false);
  const [failure, setFailure] = useState(false);
  const [hideNotification, setHideNotification] = useState(true);

  const validatePassword = (password: string): boolean => {
    return PASSWORD_REGEX.test(password);
  }

  const dispatch = useAppDispatch();

  const handleSubmit = async () => {
    // call reset password
    const token = new URLSearchParams(location.search).get('token');
    const username = new URLSearchParams(location.search).get('username');
    const resetPassword: ResetPasswordRequest = {
      username: username,
      resetPasswordToken: token,
      newPassword: newPassRef.current?.value,
    }
    const response = await dispatch(resetPasswordAsync(resetPassword));
    const status: number = JSON.parse(JSON.stringify(response.payload));
    if (status === 204) {
      setSuccess(true);
    } else {
      setFailure(true);
    }
    setHideNotification(false);
  }

  const onChangeNewPassword = (e: any) => {
    setValidNewPass(validatePassword(e.target.value));
    if (newConfPassRef.current && newConfPassRef.current?.value !== '') {
      setValidNewConfPass(newPassRef.current?.value === newConfPassRef.current?.value)
    }
  }

  const onCloseNotification = () => {
    setHideNotification(true);
    navigate('/login');
  }

  return (
    <div className='login-main'>
      <Container className='h-100'>
        <Row className='justify-content-center align-items-center h-100'>
          <Col lg="8" md sm>
            <Card className='resetPassword-card px-4 py-4'>
              <Card.Body>
                <div className='logo'>
                  <img alt='solarSharelogo' src={solarSharelogo} />
                </div>
                <div className='title'><h3>Reset your password</h3></div>
                <div className='login-form'>
                  <Form>
                    <Form.Group className="mb-3" controlId="newPassword">
                      <Form.Label>New Password</Form.Label>
                      {
                        (!isValidNewPass && hasTochedNewPass) ?
                          <Row>
                            <Col md="8">
                              <Form.Text>Use at least 8 characters, including upper and lower-case letters, numbers and special characters !@#$%^&*()</Form.Text>
                            </Col>
                          </Row> : <></>
                      }
                      <Row>
                        <Col md="8">
                          <InputGroup>
                            <Form.Control
                              ref={newPassRef}
                              isValid={isValidNewPass}
                              isInvalid={!isValidNewPass && hasTochedNewPass}
                              type={showNewPass ? 'text' : 'password'}
                              onChange={(e) => onChangeNewPassword(e)}
                              onBlur={(e) => setHasTochedNewPass(true)}
                              disabled={succuss || failure}
                            />
                            <InputGroup.Text>
                              <span
                                className='passVisible'
                                onClick={() => setShowNewPass(!showNewPass)}>
                                <i className={showNewPass ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'}>
                                </i>
                              </span>
                            </InputGroup.Text>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Form.Group>
                    <Form.Group className="mb-3" controlId="newConfPassword">
                      <Form.Label>Confirm New Password</Form.Label>
                      {
                        (!isValidNewConfPass && hasTochedNewConfPass) ?
                          <Row>
                            <Col md="8">
                              <Form.Text>Confirm password should be equal to new password</Form.Text>
                            </Col>
                          </Row> : <></>
                      }
                      <Row>
                        <Col md="8">
                          <InputGroup>
                            <Form.Control
                              ref={newConfPassRef}
                              isValid={isValidNewConfPass}
                              isInvalid={!isValidNewConfPass && hasTochedNewConfPass}
                              type={showNewConfPass ? 'text' : 'password'}
                              onChange={(e) => setValidNewConfPass(newPassRef.current?.value === newConfPassRef.current?.value)}
                              onBlur={(e) => setHasTochedNewConfPass(true)}
                              disabled={succuss || failure}
                            />
                            <InputGroup.Text>
                              <span
                                className='passVisible'
                                onClick={() => setShowNewConfPass(!showNewConfPass)}>
                                <i className={showNewConfPass ? 'fa-solid fa-eye-slash' : 'fa-solid fa-eye'}>
                                </i>
                              </span>
                            </InputGroup.Text>
                          </InputGroup>
                        </Col>
                      </Row>
                    </Form.Group>
                    {
                      (!succuss && !failure) ? <Form.Group className="mt-5">
                        <Button
                          disabled={!isValidNewPass || !isValidNewConfPass}
                          onClick={() => handleSubmit()}
                        >Reset Password</Button>
                      </Form.Group> : <>
                        {
                          (hideNotification) ? <></> : <Toast
                            style={{
                              backgroundColor: (succuss) ? '#5cb85c' : '#d9534f',
                            }}
                            className='notification'
                            onClose={() => onCloseNotification()}
                            delay={4000} autohide>
                            <Toast.Body>
                              {(succuss) ? `Password reset successfully.` : `Error occurred while resetting password`}
                            </Toast.Body>
                          </Toast>
                        }
                      </>
                    }
                  </Form>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </Container >
    </div >
  )
}

export default ResetPassword;